import { LOGIN_USER, LOG_OUT_USER } from "../_actions/userActionCreator"
import { getCachedData, getSessionData } from "../common/utils"
import { API, API_FORM } from "../api"

const cachedUser = getCachedData("Qarabao_User")
const sessionUser = getSessionData("Qarabao_User")
const emptyUser = {
  account: null,
  seller: null,
  token: null
}

//if session user exist use it,
//if not use cached user
//if not empty user
const initialUser = sessionUser || cachedUser || emptyUser
API.defaults.headers.common["x-access-token"] = initialUser.token
API_FORM.defaults.headers.common["x-access-token"] = initialUser.token

const user = (state = initialUser, action) => {
  switch (action.type) {
    case LOGIN_USER:
      API.defaults.headers.common["x-access-token"] = action.payload.token
      API_FORM.defaults.headers.common["x-access-token"] = action.payload.token
      return { ...state, ...action.payload }
    case LOG_OUT_USER:
      return { ...state, ...emptyUser }
    default:
      return { ...state }
  }
}

export default user
